import type { FC, HTMLAttributes, RefObject } from "react";
import { useEffect } from "react";

import classNames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";
import { useGoogleAPI } from "@jti/fe-clients";

import { useStoreLocatorContext } from "../../hooks";

import styles from "./StoreLocatorMap.module.scss";

type StoreLocatorMapProps = HTMLAttributes<HTMLDivElement> & {
  mapClassName?: string;
  mapWrapperRef?: RefObject<HTMLDivElement>;
};

export const StoreLocatorMap: FC<StoreLocatorMapProps> = ({ className, mapWrapperRef, mapClassName, ...rest }) => {
  const { locationServiceMapProvider } = useConfig();
  const { mapRef, handleInitMap } = useStoreLocatorContext();

  const _google = useGoogleAPI();

  useEffect(() => {
    if (_google && locationServiceMapProvider === "google") {
      handleInitMap();
    }
  }, [_google, handleInitMap, locationServiceMapProvider]);

  return (
    <div {...rest} className={classNames(className, styles.mapWrapper)} ref={mapWrapperRef}>
      <div
        ref={mapRef}
        className={classNames(mapClassName, styles.map)}
        data-testid="storeLocatorMap"
        id="storeLocatorMap"
      />
    </div>
  );
};
